import gql from "graphql-tag";

export default gql`
  query SharesHistory($tickerSymbol: TickerSymbol!) {
    sharesHistory(tickerSymbol: $tickerSymbol) {
      asOfDate
      totalSharesOutstanding
    }
  }
`;
